import { useState } from 'react'
import { formatDistanceToNow } from 'date-fns'
import { logos } from '@/utils/platform-logos'
import Sentiment from './Sentiment'

const Comment = ({ comment, platform }) => {
    const [profileImage, setProfileImage] = useState(comment.profile.imageUrl)

    return (
        <div className="tw:flex tw:gap-3">
            <img
                className="tw:w-8 tw:h-8 tw:rounded-full tw:object-cover tw:shrink-0"
                src={profileImage || logos[platform.name]}
                alt={comment.profile.username}
                onError={() => setProfileImage(logos[platform.name])}
            />
            <div className="tw:flex-1 tw:min-w-0">
                <h6 className="tw:mb-1 tw:text-sm tw:font-medium">{comment.profile.username}</h6>
                <p className="tw:mb-1 tw:text-sm">{comment.text}</p>
                <p className="tw:text-xs tw:text-gray-400">
                    {formatDistanceToNow(new Date(comment.postedAt), { addSuffix: true })}
                </p>
                <Sentiment feed={comment} />
            </div>
        </div>
    )
}

export default Comment
